import { Button } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { API } from "../global";
import "../QuestionsWrapper/allQuestions.css";
import { QuestionsList } from "../QuestionsWrapper/QuestionsList";


export function TaggedQuestions() {
    const {tagName} = useParams();
    
    const navigate = useNavigate();
    const [questionsData, setQuestionsData] = useState([]);
    const [tagDetails, setTagDetails] = useState([]);
    useEffect(function (){
        getTaggedQuestions();
    }, []);


    const getTaggedQuestions = ()=>{
        fetch(`${API}/tags/${tagName}`)
            .then((data) => data.json())
            .then((questionsData) => {
                console.log(questionsData);
                setQuestionsData(questionsData[0]);
                setTagDetails(questionsData[1]);
            })
            .catch(() => {
                console.log("error");
            });
    }

// console.log(tagDetails,questionsData,tagName);
    const askQuestion = () => {
        var userDetails = localStorage.getItem("user");
        userDetails = JSON.parse(userDetails);
        if(userDetails && userDetails.userName) {
            navigate("/questions/askquestion");
        } else {
            navigate("/users/signup");
        }
    }

    return (
        <div className='questionsBodyContent'>
          <div className="questionsHeader">
            <h1>Questions tagged [{tagName}]</h1>
            <Button type="button" variant="contained" onClick={() => askQuestion()}>Ask Question</Button>
          </div>
          <div className = "tagDescription">{tagDetails.length && tagDetails[0].description}</div>
          {/* <div className = "taotalQuestions">{tagDetails.length && tagDetails[0].totalQuestions}</div> */}
          <QuestionsList questionsData={questionsData}/>
        </div>
    );
}







